import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import store from "@src/reducers/store";
import {
  emptyNodeDataObject,
  updateNodeSelectionNodeData,
  updateNodeSelectionState,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";

export const transferInitialListToEmptyOurNodeMachineStructure = () => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const nodeManager = getNodeManager();
  nodeManager
    .transferSelectedNodesToMachineStructureHandler()
    .transferSelectedNodesToMachineStructure();

  store.dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
  store.dispatch(updateNodeSelectionState("none"));
  store.dispatch(updateStructureWasSaved(false));

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to transfer initial list to new machine structure took ${
      t1 - t0
    } milliseconds.`,
  );
};
